import { Component } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { GS1NotificationLevel, GS1NotificationService } from "@gs1france/gs1-components-library";

@Component({
  selector: 'hub',
  templateUrl: './hub.component.html',
  styleUrls: ['./hub.component.scss']
})
export class HubComponent {
  constructor() {}

}
